var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center mx-4 mb-2 pa-3 choice-container"},[_c('v-radio',{staticClass:"ma-0"}),_c('input',{staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"Type here..."}}),_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }